import { Asset, DenormalizedCustomizableQuestion, QuestionType } from '@packages/types'
import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import ThemesFileUploader from 'themes/common/components/FileUploader'
import ResolutionIndicator from 'themes/common/components/ResolutionIndicator'

import LogoAnswer from '../answer/LogoAnswer'

import './FileUploadQuestion.scss'

export interface FileUploadQuestionProps {
  question: DenormalizedCustomizableQuestion
  answersOutOfStock: string[]
  focusQuestion: () => void
  browseText?: () => string
  selectAnswer: (answerId?: string) => void
  removeAnswer: (answerId: string) => void
  createLogoAnswer: (questionId: string, asset: Asset) => void
  createAssetAnswer: (questionId: string, value: Asset) => void
}

const FileUploadQuestion = ({
  selectAnswer,
  removeAnswer,
  focusQuestion,
  browseText,
  question,
  createLogoAnswer,
  createAssetAnswer,
  answersOutOfStock,
}: FileUploadQuestionProps) => {
  const fileUploadStyle = useThemeSettings('fileUpload')

  const handleChange = (assets: Asset[]) => {
    focusQuestion()
    if (question.type === QuestionType.Value) {
      createAssetAnswer(question.id, assets[0])
    } else {
      createLogoAnswer(question.id, assets[0])
    }
  }
  const handleAnswerClick = (answerId: string) => {
    selectAnswer(answerId)
    focusQuestion()
  }

  const handleAnswerRemove = (answerId: string) => removeAnswer(answerId)

  return (
    <div className="file-upload-question" data-testid="file-upload-question">
      <ThemesFileUploader
        id={question.id}
        containerStyle={{
          backgroundColor: fileUploadStyle.backgroundColor,
          borderColor: fileUploadStyle.borderColor,
          borderRadius: fileUploadStyle.borderRadius,
        }}
        textStyle={{
          color: fileUploadStyle.fontColor,
          fontSize: fileUploadStyle.fontSize,
        }}
        linkStyle={{
          color: fileUploadStyle.linkColor,
        }}
        onChange={handleChange}
        browseText={browseText}
        extensions={
          question.allowedExtensionsByType ? Object.values(question.allowedExtensionsByType).flat() : undefined
        }
      />
      <ResolutionIndicator logoQuestion={question} />
      <div className="file-upload-question__answers">
        {question.answers.map(answer => {
          const isOutOfStock = answersOutOfStock.includes(answer.id)

          return (
            <LogoAnswer
              key={answer.id}
              answer={answer}
              selected={answer.id === question.selectedAnswer?.id}
              isRemovable={answer.isPersonalisation}
              onSelect={() => handleAnswerClick(answer.id)}
              onRemove={() => handleAnswerRemove(answer.id)}
              isOutOfStock={isOutOfStock}
            />
          )
        })}
      </div>
    </div>
  )
}

export default FileUploadQuestion
